import React, { Suspense, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Router from "./routes/router";
import Loader from "./components/loader/Loader";
import FinalHeader from "./layouts/Header";
import Footer from "./layouts/Footer/Footer";
import { FaArrowUp, FaWhatsapp } from "react-icons/fa";

function App() {
  const location = useLocation();
  const { pathname } = location;
  const [showLoader, setShowLoader] = useState(true);
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, [pathname]);

  // Show/hide the scroll-to-top button based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleWhatsappClick = () => {
    window.open("https://wa.me/+918866323228", "_blank");
  };

  return (
    <>
      <div className="flex flex-col h-screen">
        {/* Conditionally render Header */}
        {pathname !== "/" && <FinalHeader />}

        <div className="flex-1 scrollbar-hide">
          {showLoader ? (
            <Loader />
          ) : (
            <Suspense fallback={<Loader />}>
              <Router />
            </Suspense>
          )}
        </div>

        {/* Conditionally render Footer */}
        {pathname !== "/" && <Footer />}

        <div
          className="fixed bottom-4 left-4 bg-green-500 text-white p-4 rounded-full shadow-lg cursor-pointer hover:bg-green-600 animate-vibrate z-[999999999]"
          onClick={handleWhatsappClick}
        >
          <FaWhatsapp size={24} />
        </div>

        {/* Scroll-to-Top Button */}
        {showScrollTop && (
          <div
            className="fixed bottom-4 right-4 bg-primary text-white p-4 rounded-full shadow-lg cursor-pointer transition-all duration-300 z-[999999999]"
            onClick={handleScrollToTop}
          >
            <FaArrowUp size={24} />
          </div>
        )}
      </div>
    </>
  );
}

export default App;
